/* eslint-disable */

import { enhancer } from './CopyToClipboard.enhancer';
import { CopyToClipboard as View } from './CopyToClipboard';

export const CopyToClipboard = enhancer(View);
